/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="10"
        height="1"
        viewBox="0 0 10 1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 0h10v1H0z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'MinusSignIcon';

export default Icon;
